import { useApp } from "@/context/AppContext";

/** Logo perusahaan: pakai logo yang diunggah admin (Settings) bila ada, selain itu monogram default */
export function LogoMark({ size = 34, className = "" }) {
  const ctx = useApp();
  const logo = ctx?.branding?.logoDataUrl;
  if (logo) {
    return <img src={logo} alt="Logo" style={{ height: size, width: "auto", maxWidth: size * 3.4 }} className={`object-contain ${className}`} data-testid="brand-logo" />;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" className={className} data-testid="brand-logo-default">
      <rect width="64" height="64" rx="12" fill="#0B1220" stroke="#1E293B" />
      <path d="M18 14h8v16h12V14h8v36h-8V38H26v12h-8z" fill="#0EA5E9" />
      <rect x="18" y="14" width="10" height="7" fill="#F59E0B" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  const ctx = useApp();
  const name = ctx?.branding?.companyName || "PT HONGLU BAJA INDONESIA";
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={compact ? 30 : 38} />
      {!compact && (
        <div className="leading-tight">
          <div className="font-display font-bold tracking-wide text-[15px] text-slate-100">{name}</div>
          <div className="cn text-[11px] text-slate-400">宏睿钢印印尼有限公司</div>
        </div>
      )}
    </div>
  );
}
